import {useEffect, useRef} from 'react';

/**
 * Subscribes to a document-level Escape keydown while `isActive` is true.
 * Uses refs so toggling `isActive` or `onEscape` does not re-subscribe.
 */
export function useEscapeKey(isActive: boolean, onEscape: () => void): void {
  const isActiveRef = useRef(isActive);
  isActiveRef.current = isActive;

  const onEscapeRef = useRef(onEscape);
  onEscapeRef.current = onEscape;

  // eslint-disable-next-line no-restricted-syntax -- intentional: document listener needs cleanup return, useOnMount does not support it
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isActiveRef.current) {
        onEscapeRef.current();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
}
